import { Controller } from 'react-hook-form';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import InputText from '../inputs/input-text';
import { RowProps } from './types';
import formatBalance from '../../helpers/format-balance';
import IconCopy from '../icons/copy-two';

import styles from './transaction.module.css';

let timeout: NodeJS.Timeout;

export default function SidepanelAmountRow({
  title,
  name,
  value,
  control,
  enableEdit,
  placeholder,
  children,
  borderless = false,
  error,
  disabled,
  fieldValue,
  setFieldValue,
  tabIndex,
  isFixedExchangeAmount,
  currenciesList,
  currencyId,
  exchangeFieldType,
  isCreate,
  copyEnabled,
  copyValue,
  className,
  withoutFormatting,
  calculateTransactionRatesByIdAction,
  clearErrors,
}: RowProps): React.JSX.Element {
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    setCopyIsSuccess(true);
    copy(copyValue as string);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  let content;

  const currentCurrency = currenciesList?.find(
    (item) => item.id === currencyId,
  );

  if (enableEdit) {
    content = (
      <Controller
        name={name}
        control={control}
        rules={{ required: false }}
        defaultValue={value}
        render={({ field }) => (
          <InputText
            title={title}
            name={name}
            value={fieldValue || field.value}
            tabIndex={tabIndex}
            onChange={(e) => {
              if (error && clearErrors) {
                clearErrors([name]);
              }

              if (setFieldValue) {
                clearTimeout(timeout);

                setFieldValue(e.target.value);

                if (e.target.value) {
                  timeout = setTimeout(() => {
                    field.onChange(
                      isFixedExchangeAmount
                        ? Number(e.target.value)
                        : e.target.value,
                    );

                    if (
                      !isCreate &&
                      calculateTransactionRatesByIdAction &&
                      exchangeFieldType
                    ) {
                      calculateTransactionRatesByIdAction(
                        {
                          exchangeActualRate:
                            exchangeFieldType === 'rate'
                              ? Number(e.target.value)
                              : undefined,
                          exchangeMarginPercent:
                            exchangeFieldType === 'margin'
                              ? Number(e.target.value)
                              : undefined,
                        },
                        exchangeFieldType,
                      );
                    }
                  }, 400);
                } else if (!e.target.value.length) {
                  clearTimeout(timeout);
                  field.onChange('');
                }
              } else {
                field.onChange(e);
              }
            }}
            placeholder={placeholder as string}
            className={`${borderless ? 'borderless' : ''} `}
            error={error}
            disabled={disabled}
            currency={currentCurrency}
            amountInput={!withoutFormatting}
          />
        )}
      />
    );
  } else {
    content = children || formatBalance(Number(value), currentCurrency);
  }

  return (
    <SidepanelDefaultRow
      title={enableEdit ? undefined : title}
      valueClassName={`${copyEnabled && enableEdit ? styles.rowWithCopy : ''} ${
        copyEnabled && !enableEdit ? styles.readCopyButtonWrapper : ''
      }`}
      wrapperClassName={className || ''}
    >
      {content}
      {copyEnabled && (
        <>
          {enableEdit && (
            <button
              type="button"
              className={`${styles.copyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
          {!enableEdit && (
            <button
              type="button"
              className={`${styles.readCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
        </>
      )}
    </SidepanelDefaultRow>
  );
}
